// third-party
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

// project import
import { apiSlice } from './features/api/apiSlice';
import { socketSlice } from './features/api/socketSlice';
import menuSliceReducer from './features/menu/menuSlice';
import authSliceReducer from './features/auth/authSlice';
import profileSliceReducer from './features/profile/profileSlice';
import processSliceReducer from './features/process/processSlice';
import mainSliceReducer from './reducer/mainSlice';
import leaseSliceReducer from './reducer/lease-management/leaseSlice';

export const rootReducer = combineReducers({
	[apiSlice.reducerPath]: apiSlice.reducer,
	[socketSlice.reducerPath]: socketSlice.reducer,
	main: mainSliceReducer,
	menu: menuSliceReducer,
	auth: authSliceReducer,
	profile: profileSliceReducer,
	process: processSliceReducer,
	lease: leaseSliceReducer,
});

const persistConfig = {
	key: 'root',
	storage: storageSession,
	whitelist: ['menu'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
	reducer: persistedReducer,
	/* eslint-disable-next-line */
	devTools: {
		actionsDenylist: ['api/executeMutation/fulfilled', 'api/executeMutation/pending'],
		stateSanitizer: (state) => {
			// Completely hide api slice from Redux DevTools
			const newState = { ...state };
			delete newState.api;
			return newState;
		},
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).concat(apiSlice.middleware, socketSlice.middleware),
});

const persistor = persistStore(store);
setupListeners(store.dispatch);

const { dispatch } = store;

export { store, dispatch, persistor };
